import { Component, Input, Output, EventEmitter } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { ItemsService } from '../../../personal-income-tax/using-register/items.service';

@Component({
  selector: 'app-dialog-view-tvan-using-register',
  templateUrl: './dialog-view-tvan-using-register.component.html'
})
export class DialogViewTvanUsingRegisterComponent {

  baseURL: string = environment.baseURL;

  @Input() display?: number;
  @Input() agreement: any;
  @Input() tVanLogs: Array<any> = new Array<any>();
  @Output() onPullSuccess = new EventEmitter<any>();

  constructor(
    private itemsService: ItemsService,
  ) {
  }

  pullTVan(): void {
    if (this.agreement && this.agreement.agreementId) {
      let agreementId = this.agreement.agreementId;
      this.itemsService.pullTVan(agreementId).subscribe(() => {
        this.onPullSuccess.emit();
      });
    }
  }

  downloadXml(rowData: any): void {
    if (rowData && rowData.systemMessageId) {
      if (this.agreement.agreementId) {
        window.open(`${this.baseURL}/iam-tvan/agrt-using-register/${rowData.systemMessageId}/xml`);
      } else if (this.agreement.taxWithholdCertId) {
        window.open(`${this.baseURL}/iam-tax/cert-income-tax/${this.agreement.taxWithholdCertId}/tvan-log/${rowData.systemMessageId}/xml`);
      }
    }
  }

}
